import Head from 'next/head'
import { useTranslation } from 'hooks/useTranslation'
import { RawFoodSubscription } from 'features/Landings/screens/RawFoodSubscription'
import Script from 'next/script'
const RawFoodSubscriptionPage = () => {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'The Best Raw Dog Food Subscription',
    url: 'https://wefeedraw.com/raw-food-subscription',
    description:
      'Never get overwhelmed in the dog food aisle again. We Feed Raw is one of the only subscription meal delivery services for dogs based on the raw food diet. Keeping your dog happy and healthy with easy-to-serve raw meals has never been this simple.',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'WebPage',
            name: 'How it works',
            url: 'https://wefeedraw.com/raw-food-subscription#raw-food-subscription-1',
            description: 'Start your dog food subscription service in three easy steps.',
            about: {
              '@type': 'CreativeWork',
              name: 'How it works',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'WebPage',
            name: 'A Smart, Fresh Dog Food Subscription',
            url: 'https://wefeedraw.com/raw-food-subscription#raw-food-subscription-2',
            description: 'Feeding raw is a full-time job. Ours.',
            about: {
              '@type': 'CreativeWork',
              name: 'A Smart, Fresh Dog Food Subscription',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'WebPage',
            name: 'The We Feed Raw Difference',
            url: 'https://wefeedraw.com/raw-food-subscription#raw-food-subscription-3',
            description:
              'We Feed Raw is the best raw food subscription for dogs specializing in nutritious pre-portioned meals that are ready to be thawed and served.',
            about: {
              '@type': 'CreativeWork',
              name: 'The We Feed Raw Difference',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        }
      ]
    }
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <>
      <Head>
        <title>{t('raw-food-subscription:page-title')}</title>
        <meta name="title" content={t('raw-food-subscription:page-title')} />
        <meta name="description" content={t('raw-food-subscription:meta-description')} />
        <meta
          name="keywords"
          content="raw dog food subscription, dog food subscription, dog food subscriptions, raw food subscription for dogs, best dog food subscription, subscription dog food, fresh dog food subscription, dog food monthly subscription, dog food subscription service, dog raw food diet subscription, subscription meal plan for dogs"
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://wefeedraw.com/raw-food-subscription" />
      </Head>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
      <RawFoodSubscription />
    </>
  )
}

export default RawFoodSubscriptionPage
